export default __webpack_public_path__ + "static/media/bg-bobike.e580c808.jpg";